var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.167,
    height: 23.167,
    viewBox: "0 0 23.167 23.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5529",
    "data-name": "Caminho 5529",
    d: "M16.265,0H6.9A6.909,6.909,0,0,0,0,6.9v9.364a6.909,6.909,0,0,0,6.9,6.9h9.364a6.909,6.909,0,0,0,6.9-6.9V6.9A6.909,6.909,0,0,0,16.265,0Zm4.571,16.265a4.571,4.571,0,0,1-4.571,4.571H6.9a4.571,4.571,0,0,1-4.571-4.571V6.9A4.571,4.571,0,0,1,6.9,2.331h9.364A4.571,4.571,0,0,1,20.836,6.9v9.364Z",
    fill: "#d8dfe8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5530",
    "data-name": "Caminho 5530",
    d: "M138.992,133a5.992,5.992,0,1,0,5.992,5.992A6,6,0,0,0,138.992,133Zm0,9.653a3.661,3.661,0,1,1,3.661-3.661A3.661,3.661,0,0,1,138.992,142.653Z",
    transform: "translate(-127.408 -127.408)",
    fill: "#d8dfe8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 1.436,
    cy: 1.436,
    r: 1.436,
    transform: "translate(16.151 4.201)",
    fill: "#d8dfe8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d661816116b7a9a8da1cf798ab3025a9.svg";
export { ForwardRef as ReactComponent };